// constants.js — dashboard-wide tunables.
//
// Numbers and short strings that more than one module reads. Each
// caller imports the specific constants it needs, named.
//
// New constants: only add here when they're shared across modules.
// Constants used by a single page or helper should stay local.

// EVENTS_PAGE_SIZE: events page pagination. Bigger pages = fewer
// clicks but slower initial render on long lease histories. 50 is
// the user-validated middle ground.
export const EVENTS_PAGE_SIZE = 50;

// CHATS_PAGE_SIZE: chats page pagination. Smaller than events
// because chat cards are visually taller — fewer per page keeps
// the cards visible above the fold.
export const CHATS_PAGE_SIZE = 10;
